import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import AppLogout from "../components/timeOutAlert";
import { USERS_TYPE } from "../data/Constants";

const ProtectedRoute = ({ children }) => {
  const user = useSelector((state) => state.auth.user);

  return user && user.user_type === USERS_TYPE.USER ? (
    <AppLogout>{children}</AppLogout>
  ) : (
    <Navigate to="/" replace />
  );
};

export default ProtectedRoute;
